import FormInput from "./FormInput";

interface Props {
    locationData: any
    setLocationData: (data: any) => void
    locationFieldsDisabled: boolean,
}

export const SpacewellPolicy = (props: Props) => {

    const {locationData, setLocationData, locationFieldsDisabled} = props

    if (locationFieldsDisabled) {
        return null
    }

    return (
        <div className={'c-spacewell-policy'}>
            <div className={'c-spacewell-policy__message'}>
                <p>
                    Door op de volgende knop te klikken, wordt uw informatie aan Hoorne Vastgoed
                    overgedragen,
                    die ze zal gebruiken om met u te communiceren over dit verzoek en andere
                    relevante inhoud, producten en diensten.</p>

                <p>U kunt zich op elk moment uitschrijven van deze communicaties.</p>

                <p>U stemt ermee in dat Hoorne Vastgoed uw persoonsgegevens voor deze doeleinden en zoals
                    beschreven in het privacybeleid bewaart en verwerkt.</p>

                <p>Uw informatie zal niet met derden worden gedeeld</p>
            </div>

            <FormInput
                label={'Ik ga ermee akkoord om berichten van Hoorne Vastgoed te ontvangen.'}
                name={'approveSpaceWell'}
                type={'checkbox'}
                value={locationData.approveSpaceWell}
                onChange={(data) => setLocationData({...locationData, approveSpaceWell: data.checked})}
                disabled={locationFieldsDisabled}
                required={true}
            />

        </div>
    )
}